import { Routes } from '@angular/router';

import { AppChatComponent } from './chat/chat.component';
import { AppEmailComponent } from './email/email.component';
import { DetailComponent } from './email/detail/detail.component';
import { AppCoursesComponent } from './courses/courses.component';
import { AppCourseDetailComponent } from './courses/course-detail/course-detail.component';
import { AppEmployeeComponent } from './employee/employee.component';
import { AppBlogsComponent } from './blogs/blogs.component';
import { AppBlogDetailsComponent } from './blogs/details/details.component';
import { AppContactComponent } from './contact/contact.component';
import { AppNotesComponent } from './notes/notes.component';
import { AppTodoComponent } from './todo/todo.component';
import { AppPermissionComponent } from './permission/permission.component';
import { AppKanbanComponent } from './kanban/kanban.component';
import { AppFullcalendarComponent } from './fullcalendar/fullcalendar.component';
import { AppTicketlistComponent } from './tickets/tickets.component';
import { AppInvoiceListComponent } from './invoice/invoice-list/invoice-list.component';
import { AppAddInvoiceComponent } from './invoice/add-invoice/add-invoice.component';
import { AppInvoiceViewComponent } from './invoice/invoice-view/invoice-view.component';
import { AppEditInvoiceComponent } from './invoice/edit-invoice/edit-invoice.component';
import { AppContactListComponent } from './contact-list/contact-list.component';
import { KeycloakMatching } from "./keyCloak/keycloak-matching";
import { RoleMappingComponent } from './keyCloak/role-mapping/role-mapping.component';
import { LlmSettingsComponent } from './llm-settings/components/llm-settings/llm-settings.component';
import { PromptManagementComponent } from './prompt-management/components/prompt-management/prompt-management.component';
import { PromptCreateComponent } from './prompt-management/components/prompt-create/prompt-create.component';
import {AppFileUploadFormWizardComponent} from "./file/file-upload-form-wizard/file-upload-form-wizard.component";
import {ResourceManagementComponent} from "./file/resource-management/resource-management.component";
import { OrganizationListComponent } from './organization/components/organization-list/organization-list.component';
import { OrganizationDetailComponent } from './organization/components/organization-detail/organization-detail.component';
import {RoleManagementComponent} from "./role-management/role-management/role-management.component";
import {SystemRoleManagementComponent} from "./role-management/system-role-management/system-role-management.component";
import { SystemUserListComponent } from './system-user/components/system-user-list/system-user-list.component';
import {
  OrganisationUserListComponent
} from "./organisation-user/components/system-user-list/organisation-user-list.component";
import { NavLessComponent } from 'src/app/layouts/navLess/navLess.component';


export const AppsRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'keycloak',
        component: KeycloakMatching,
        data: {
          permissions: ['KEYCLOK_MANAGEMENT_VIEW'],
          title: 'KeyCloak Settings',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'KeyCloak Settings' },
          ],
        },
      },
      {
        path: 'chat',
        component: NavLessComponent,
        pathMatch: 'full',
        children: [
          {
            path: '',
            component: AppChatComponent,
          },
        ],
      },
      {
        path: 'file-upload',
        component: AppFileUploadFormWizardComponent,
        data: {
          permissions: ['UPLOAD_FILE'],
          title: 'Upload Resource',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Upload Resource' },
          ],
        },
      },
      {
        path: 'resource-management',
        component: ResourceManagementComponent,
        data: {
          permissions: ['VIEW_RESOURCE_ROLE'],
          title: 'Resource Management',
          urls: [
            { title: 'Upload Resource', url: '/apps/file-upload' },
            { title: 'Resource Management' }
          ]
        }
      },
      {
        path: 'organization',
        component: OrganizationListComponent,
        data: {
          title: 'Organizations',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Organizations' }
          ]
        }
      },
      {
        path: 'organization/detail/:id',
        component: OrganizationDetailComponent,
        data: {
          title: 'Organization Details',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Organizations', url: '/apps/organization' },
            { title: 'Organization Details' }
          ]
        }
      },
      {
        path: 'role-management',
        component: RoleManagementComponent,
        data: {
          permissions: ['VIEW_ORGANISATION_ROLE'],
          title: 'Role Management',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Role Management' }
          ]
        }
      },
      {
        path: 'system-role-management',
        component: SystemRoleManagementComponent,
        data: {
          permissions: ['VIEW_SYSTEM_ROLE'],
          title: 'System Role Management',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'System Role Management' }
          ]
        }
      },
      {
        path: 'calendar',
        component: AppFullcalendarComponent,
        data: {
          title: 'Calendar',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Calendar' },
          ],
        },
      },
      {
        path: 'notes',
        component: AppNotesComponent,
        data: {
          title: 'Notes',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Notes' },
          ],
        },
      },
      { path: 'email', redirectTo: 'email/inbox', pathMatch: 'full' },
      {
        path: 'email/:type',
        component: AppEmailComponent,
        data: {
          title: 'Email',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Email' },
          ],
        },
        children: [
          {
            path: ':id',
            component: DetailComponent,
            data: {
              title: 'Email Detail',
              urls: [
                { title: 'Home', url: '/dashboard' },
                { title: 'Email Detail' },
              ],
            },
          },
        ],
      },
      {
        path: 'permission',
        component: AppPermissionComponent,
        data: {
          title: 'Roll Base Access',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Roll Base Access' },
          ],
        },
      },
      {
        path: 'todo',
        component: AppTodoComponent,
        data: {
          title: 'Todo App',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Todo App' },
          ],
        },
      },
      {
        path: 'kanban',
        component: AppKanbanComponent,
        data: {
          title: 'Kanban',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Kanban' },
          ],
        },
      },
      {
        path: 'tickets',
        component: AppTicketlistComponent,
        data: {
          title: 'Tickets',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Tickets' },
          ],
        },
      },
      {
        path: 'contacts',
        component: AppContactComponent,
        data: {
          title: 'Contacts',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Contacts' },
          ],
        },
      },
      {
        path: 'courses',
        component: AppCoursesComponent,
        data: {
          title: 'Courses',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Courses' },
          ],
        },
      },
      {
        path: 'contact-list',
        component: AppContactListComponent,
        data: {
          title: 'Contact List',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Contact List' },
          ],
        },
      },
      {
        path: 'courses/coursesdetail/:id',
        component: AppCourseDetailComponent,
        data: {
          title: 'Course Detail',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Course Detail' },
          ],
        },
      },
      {
        path: 'blog/post',
        component: AppBlogsComponent,
        data: {
          title: 'Posts',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Posts' },
          ],
        },
      },
      {
        path: 'blog/detail/:id',
        component: AppBlogDetailsComponent,
        data: {
          title: 'Blog Detail',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Blog Detail' },
          ],
        },
      },
      {
        path: 'employee',
        component: AppEmployeeComponent,
        data: {
          title: 'Employee',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Employee' },
          ],
        },
      },
      {
        path: 'invoice',
        component: AppInvoiceListComponent,
        data: {
          title: 'Invoice',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Invoice' },
          ],
        },
      },
      {
        path: 'addInvoice',
        component: AppAddInvoiceComponent,
        data: {
          title: 'Add Invoice',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Add Invoice' },
          ],
        },
      },
      {
        path: 'viewInvoice/:id',
        component: AppInvoiceViewComponent,
        data: {
          title: 'View Invoice',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'View Invoice' },
          ],
        },
      },
      {
        path: 'editinvoice/:id',
        component: AppEditInvoiceComponent,
        data: {
          title: 'Edit Invoice',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Edit Invoice' },
          ],
        },
      },
      {
        path: 'keycloak/role-mapping',
        component: RoleMappingComponent,
        data: {
          title: 'KeyCloak.RoleMapping.Title',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'KeyCloak Settings', url: '/apps/keycloak' },
            { title: 'KeyCloak.RoleMapping.Title' }
          ]
        }
      },
      {
        path: 'llm-settings',
        component: LlmSettingsComponent,
        data: {
          title: 'LLM Settings',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'LLM Settings' }
          ]
        }
      },
      {
        path: 'prompt-management',
        component: PromptManagementComponent,
        data: {
          title: 'Prompt Management',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Prompt Management' }
          ]
        }
      },
      {
        path: 'prompt-management/create',
        component: PromptCreateComponent,
        data: {
          title: 'Prompts.Create.Title',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'Prompt Management', url: '/apps/prompt-management' },
            { title: 'Prompts.Create.Title' }
          ]
        }
      },
      {
        path: 'system-user',
        component: SystemUserListComponent,
        data: {
          permissions: ['VIEW_SYSTEM_USER'],
          title: 'System Users',
          urls: [
            { title: 'Home', url: '/dashboard' },
            { title: 'System Users' }
          ]
        }
      },
      {
        path: 'organisation-user',
        component: OrganisationUserListComponent,
        data: {
          title: 'Organisation Users',
          urls: [
            { title: 'Home', url: '/dashboards/dashboard1' },
            { title: 'Organisation Users' }
          ]
        }
      }
    ],
  },
];
